import { z } from 'zod';
import { emailValidationSchema } from '@/schemas/ValidationSchema.ts';

export const tpayRegisterSchema = z.object({
  email: emailValidationSchema,
  consent: z.literal(true, { error: 'Musisz zaakceptować zgodę' }),
});

export type TpayRegisterFormData = z.infer<typeof tpayRegisterSchema>;

export const tpayRegisterDefaultValues: TpayRegisterFormData = {
  email: '',
  consent: false as unknown as true,
};
